var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"cols":"12","md":"6"}},[_c('v-btn',{staticClass:"ma-2",attrs:{"dark":"","color":"primary"},on:{"click":_vm.exportReport}},[_c('v-icon',[_vm._v("mdi-file-chart")]),_vm._v(" "+_vm._s(_vm.$t('admin.dashboard.exportReccognitionsReport'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }